/**
 * Created by 枯荣<panjiankang@cai-inc.com> on 2019-08-01 14:34.
 */
const BaseComponent = require( 'base/base-component' );
const Query = require( 'helper/query' );
const ESClient = require( 'helper/es-client' );

const searchlTpl = Handlebars.templates[ 'templates/search-tpl' ];

class CategoryPage extends BaseComponent {
  constructor( obj ) {
    let params = {
      events: {
        'change .page-size': 'changPageSize',
        'click .dropdown-menu': 'changPageSize',
        'keydown .h-search #keyword': 'searchEvent',
        'click .h-search #search': 'searchEvent',
        'input .h-search #keyword': 'showClear',
        'click .h-search .icon-Shape': 'clearSearch',
        'click .catalog .iconfont': 'collapseCatalog',
        'click #advancedSearch': 'advancedSearch'
      }
    };
    const defaultConfig = {
      hightSearch: true
    };
    const config = _.extend( defaultConfig, obj.config || {} );
    if (obj && obj.events) {
      params.events = _.extend( params.events, obj.events );
    }
    super( params );
    this.config = config;
  }

  async init() {
    this.query = new Query();
    this.query.params.districtCode && typeof this.query.params.districtCode === 'string' && ( this.query.params.districtCode = this.query.params.districtCode.split( ',' ) );
    this.previewFlag = this.isFromPreview();
    this.pageNo = 1;
    this.pageSize = 15;
    this.client = new ESClient();
    this.$nav = this.$el.find( '.list__nav' );
    this.$navContent = this.$el.find( '.list__nav-content' );
    this.$content = this.$el.find( '.list__content' );
    this.$bread = this.$el.find( '.list__bread' );
    this.$searchPanel = this.$el.find( '.list__search' );
    const allTitle = this.$nav.find('.list__nav-title').text().trim();
    const share = this.$nav.find('#category-qr-show').text().trim();
    this.rootType = allTitle.replace(share,"").trim();
    // this.rootType = this.$nav.find( '.list__nav-title' ).text().trim();
    const categoryTreeData = await this.treeData();
    this.initTree( categoryTreeData );
    this.fixMenu();
  }

  handleSearch(){
    const isFun = (this.search) instanceof Function;
    if(isFun){
      this.search()
    }
  }

  treeData() {
    return JSON.parse( this.$el.find( '[name=tree-data]' ).text() );
  }

  initTree( categoryTreeData ) {
    let that = this;
    let mid = that.query.get( 'mid' );
    let param = null;
    if (categoryTreeData.children && categoryTreeData.children instanceof Array) {
      // 若此分类没有子分类，理应可以用不用构建jstree，但是需用复用下面的一些列逻辑，所以选择隐藏jstree
      if (categoryTreeData.children.length === 0) {
        param = [ categoryTreeData ];
        $( '.list-nav-content' ).hide();
      } else {
        param = categoryTreeData.children;
      }
    } else {
      param = categoryTreeData;
    }
    initTreeSelected( param, mid );
    /**
     * 菜单
     */
    that.$navContent
        .jstree( {
          plugins: [ 'conditionalselect', 'wholerow' ],
          conditionalselect: ( ...arg ) => that.conditionalselect( ...arg ),
          core: {
            data: param,
            animation: 300
          }
        } )
        .on( 'ready.jstree', ( e, { instance } ) => {
          // 渲染面包屑
          this.renderBreadcrumb( instance );
          // 初始化搜索框
          this.config.hightSearch && this.initSearchPanel();
          that.handleSearch();
        } )
        .on( 'before_open.jstree', closeSiblingLeaf )
        .on( 'select_node.jstree', ( ...arg ) => this.selectTreeNode( ...arg ) );
  }

  renderBreadcrumb( instance ) {
    const { text, parents: list } = this.selectedTreeNode;
    let arr = [ text ];
    for (let i = 0, len = list.length - 1; i < len; i ++) {
      arr.unshift( instance.get_node( list[ i ] ).original.text );
    }
    arr.unshift( this.rootType );
    const s = arr.join( ' > ' );

    this.$bread.find( '#nav' ).text( s );
    if ($( '#blockTitleIcon' ).val()) {
      this.$content.find( '.block__title' ).html( `<i class="icon iconfont ${ $( '#blockTitleIcon' ).val() }" style="font-size:14px;margin-right:9px;"></i><span>${ text }</span>` );
    } else {
      this.$content.find( '.block__title' ).text( text );
    }
  }

  get selectedTreeNode() {
    let tree = this.$navContent.jstree( true );
    const selected = _.clone( tree.get_node( tree.get_selected() ) );
    return $.extend( selected, selected.original );
  }

  clearSearch( e ) {
    let $searchInp = this.$searchPanel.find( '#keyword' );
    $searchInp.val( '' );
    $( e.target ).hide();
    this.pageNo = 1;
    this.query = new Query();
    this.handleSearch();
  }

  showClear( e ) {
    const $ele = $( e.currentTarget );
    if ($ele.val().length > 0) {
      this.$el.find( '.h-search .icon-Shape' ).show();
    } else {
      this.$el.find( '.h-search .icon-Shape' ).hide();
    }
  }

  /**
   * 采购目录展开收起
   * @param {*} e
   */
  collapseCatalog( e ) {
    const $target = $( e.currentTarget );
    const $tr = $target.closest( 'tr' );
    const depth = $tr.data( 'depth' );
    const $leaf = $tr.nextUntil( `[data-depth=${ depth }]` );
    if ($target.hasClass( 'icon-xiangxiazhedie' )) {
      $target.removeClass( 'icon-xiangxiazhedie' ).addClass( 'icon-xiangshangzhedie' );
      $leaf.hide();
    } else {
      $target.removeClass( 'icon-xiangshangzhedie' ).addClass( 'icon-xiangxiazhedie' );
      $leaf.show();
    }
  }

  changPageSize( e ) {
    this.pageSize = $( e.target ).data( 'num' ) || $( e.target ).val();
    this.pageNo = 1;
    this.handleSearch();
  }

  selectTreeNode( event, data ) {
    const url = data.instance.get_node( data.instance.get_selected()[ 0 ] ).original.url;
    // location.href = url;
    location.href = `${ url }${ window.location.search }`;
  }

  isFromPreview() {
    const isFromPreview = this.query.get( 'PID' );
    if (isFromPreview) {
      // 后台预览时禁用点击
      document.body.addEventListener( 'click', ( e ) => {
        e.preventDefault();
        return false;
      }, true );
    }
    return isFromPreview;
  }

  searchEvent( e ) {
    if (e.type === 'keydown' && e.keyCode == 13) {
      this.query.init();
      this.query.set( 'keyword', $( e.currentTarget ).val().trim() );
    } else if (e.type === 'click') {
      this.query.init();
      this.query.set( 'keyword', $( e.currentTarget ).siblings( '#keyword' ).val() );
    } else if (e.type === 'keydown') {
      return;
    }
    this.pageNo = 1;
    this.$content.find( '.block__title' ).text( '搜索结果' );
    this.handleSearch();
  }

  /**
   * @param showContent true:显示文章,false:显示列表
   */
  initSearchPanel() {
    const { showContent = false } = this.selectedTreeNode;
    if (showContent) {
      this.$searchPanel.html( '' );
    } else {
      this.$searchPanel.html( searchlTpl );
    }
  }

  /**
   * 初始化分页
   * @param count 总条数
   */
  initPagination( count ) {
    let that = this;
    let sources = ( function() {
      let result = [];
      count > 9900 && ( count = 9900 ); // es不支持index大于10000的分页查询
      for (let i = 0; i < count; i ++) {
        result.push( i );
      }
      return result;
    } )();
    that.pageSize = that.$el.find( '.pagination-container .page-size' ).val() || that.pageSize || 15;
    /* eslint-disable */
    let options = {
      dataSource: sources,
      totalNumber: count,
      pageSize: that.pageSize,
      pageNumber: that.pageNo,
      prevText: '<',
      nextText: '>',
      showGoInput: true,
      showGoButton: true,
      beforeGoButtonOnClick: ( event, pageNumber ) => {
        let lastPageNo = $( '.paginationjs-last' ).data( 'num' );
        if (! lastPageNo) {
          lastPageNo = $( '.J-paginationjs-page:last' ).data( 'num' );
        }
        if (pageNumber > lastPageNo) {
          alert( '跳转页数不得大于最大页数' );
          return;
        }
        if (pageNumber >= 1) {
          that.pageNo = pageNumber;
          that.handleSearch();
        }
      },
      beforePageOnClick: ( event, pageNumber ) => {
        that.pageNo = pageNumber;
        that.handleSearch();
      },
      beforeGoInputOnEnter: ( event, pageNumber ) => {
        let lastPageNo = $( '.paginationjs-last' ).data( 'num' );
        if (! lastPageNo) {
          lastPageNo = $( '.J-paginationjs-page:last' ).data( 'num' );
        }
        if (! /^\d+$/.test( pageNumber ) || pageNumber > lastPageNo || pageNumber < 1) {
          alert( '跳转页数不合法' );
          return;
        }
        that.pageNo = pageNumber;
        that.handleSearch();
      },
      beforePreviousOnClick: () => {
        that.pageNo --;
        that.handleSearch();
      },
      beforeNextOnClick: () => {
        that.pageNo ++;
        that.handleSearch();
      }
    };
    /* eslint-enable */
    that.$el.find( '.pagination-container .pagination-list' )[ 0 ] && that.$el.find( '.pagination-container .pagination-list' ).pagination( options );
  }

  fixMenu() {
    const { top } = this.$content.offset();
    $( window ).on( 'scroll', () => {
      let h = this.$content.height();
      let st = $( document ).scrollTop();
      if (h > 800) {
        if (st > top && st < h - 260) {
          this.$nav.css( {
            position: 'fixed',
            top: '0'
          } );
        } else if (st >= h - 260) {
          this.$nav.css( {
            position: 'absolute',
            top: h - 700
          } );
        } else {
          this.$nav.css( {
            position: 'absolute',
            top: '0'
          } );
        }
      } else {
        this.$nav.css( {
          position: 'absolute',
          top: '0'
        } );
      }
    } );
  }

  advancedSearch() {
  }

  // 菜单选中条件
  conditionalselect() {
    if (this.previewFlag) {
      return false;
    }
    return true;
  }
}

module.exports = CategoryPage;


/**
 * 初始化tree默认选中
 * @param treeData tree的data对象
 * @param mid 要选中treenode的id
 */
function initTreeSelected( treeData, mid ) {
  const select = ( data ) => {
    for (let i = 0, len = data.length; i < len; i ++) {
      const item = data[ i ];
      let { selected, children } = item;
      if (selected) {
        item.state = { selected: true };
        return true;
      }
      if (children) {
        if (select( children )) {
          return true;
        }
      }
    }
  };
  const selectWithid = ( data ) => {
    for (let i = 0, len = data.length; i < len; i ++) {
      const item = data[ i ];
      if (item.id == mid) {
        item.state = { selected: true };
        break;
      }
      if (item.children) {
        selectWithid( item.children );
      }
    }
  };
  const selectDefault = ( data ) => {
    if (data instanceof Array) {
      if (data[ 0 ].children && data[ 0 ].children.length > 0) {
        selectDefault( data[ 0 ].children );
      } else {
        data[ 0 ].state = { selected: true };
      }
    } else {
      data.state = { selected: true };
    }
  };
  if (mid) {
    selectWithid( treeData );
  } else {
    ! select( treeData ) && selectDefault( treeData );
  }
}

/**
 * jstree二级分类闭合同级节点
 * @param {*} event
 * @param {*} data
 */
function closeSiblingLeaf( event, data ) {
  let arr = null;
  if (data.node.parents.length == 1) {
    arr = data.instance.get_node( data.node.parent ).children.slice();
    arr.splice( arr.indexOf( data.node.id ), 1 );
    for (let i = 0, len = arr.length; i < len; i ++) {
      let itemNode = data.instance.get_node( arr[ i ] );
      if (
        data.instance.is_parent( itemNode ) &&
        data.instance.is_open( itemNode )
      ) {
        data.instance.close_node( itemNode, 200 );
      }
    }
  }
}
